<template>
    <div class="pding">
    <h2 class="label" :class="requiredClass">
      {{ question }}
      <a v-if="answer" v-on:click.stop="clearAnswer" class="ml-1 is-size-7 has-text-weight-normal">undo</a>
    </h2>
    
    <div v-if="options.length > 0" class="options-area">
      <div class="field" v-for="option in options"  :key="option.id">
              <b-radio @input="handleInput" v-model="answer" :name="option.id"
                  :native-value="option.value" :required="udidQuestion.isRequired">
                  {{option.label}}
              </b-radio>
      </div>
    </div>
    <!-- <div  v-else-if="type == 'cb'">
      <div class="field" v-for="option in options"  :key="option">
        <b-checkbox @input="handleInput" v-model="answer" :name="option"
          :native-value="option">
          {{option}}
      </b-checkbox>
      </div>
    </div> -->
    <div  v-else>
      <div class="field">
        <b-input @input="handleInput" v-model="answer" :required="udidQuestion.isRequired" maxlength="116"></b-input>
      </div>
    </div>

        </div>
</template>

<script>
    export default {
      name: 'Questions',
      data() {
          return {
              answer: null,
              question: this.udidQuestion.question,
              options: this.udidQuestion.options,
              requiredOrOptional: this.udidQuestion.isRequired ? '*' : '',
              requiredAttr: this.udidQuestion.isRequired ? 'required' : null,
              requiredClass: this.udidQuestion.isRequired ? 'is-required' : null,
          }
      },
      props: {
        udidQuestion: Object,
      },
      methods: {
        handleInput () {
          this.$emit('input', this.answer)
        },
        clearAnswer () {
          this.answer = null
          this.$emit('input', this.answer)
        }
      },

      watch: {
        collect: {
          // the callback will be called immediately after the start of the observation
          immediate: true,
          handler () {
            if (this.collect) {
              this.$emit('collected', {ans: this.answer, q: this.question})
            }
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
.pding {
  padding: 10px;
}

.options-area {
  max-height: 155px; 
  overflow-y: scroll; 
  border: 1px solid #dbdbdb; 
  border-radius: 5px; 
  padding: 10px;
}

.label {
  &.is-required {
    font-weight: bold;
    &:after {
      content: "* required";
      font-weight: normal;
      font-size: 11px;
      color: red;
      margin-right: 6px;
    }
  }
}


</style>
